module.exports = __webpack_public_path__ + "static/gem-betterer-b18a35fe4f188555d6015fc34de85a3d.png";